import { Observable } from '@code-expert/fp-ts-rxjs';
import { array, eq } from '@code-expert/prelude';
import { eqEntityById } from './Entity.js';
import { publicationEventAdt } from './PublicationEvent.js';
export const singletonReducer = (event) => (prevState) => {
    const panic = (message) => {
        const cause = { prevState, event };
        throw new Error(message, { cause });
    };
    const isSameEntity = eq.isEqualTo(eqEntityById);
    return publicationEventAdt().fold(event, {
        initial: (es) => {
            if (es.length > 1 || es[0] == null)
                panic('Singleton publication did not receive a singular entity');
            else
                return es[0];
        },
        insert: (e) => {
            if (!isSameEntity(e)(prevState))
                panic('Singleton publication received extraneous entity');
            else
                return e;
        },
        update: (e) => {
            if (!isSameEntity(e)(prevState))
                panic('Singleton publication received update to wrong entity');
            else
                return e;
        },
        delete: () => panic('Singleton publication received delete'),
    });
};
export const aggregateSingleton = () => (source) => new Observable((subscriber) => {
    let state;
    return source.subscribe({
        complete: () => void subscriber.complete(),
        error: (e) => void subscriber.error(e),
        next: (event) => {
            if (state == null) {
                if (event._tag !== 'initial') {
                    subscriber.error(new Error('Singleton publication received update before initialisation', {
                        cause: { event },
                    }));
                }
                else {
                    if (!array.isSingleton(event.value)) {
                        subscriber.error(new Error('Singleton publication did not receive a singular entity', {
                            cause: { event },
                        }));
                    }
                    else {
                        subscriber.next((state = event.value[0]));
                    }
                }
            }
            else {
                try {
                    subscriber.next((state = singletonReducer(event)(state)));
                }
                catch (e) {
                    subscriber.error(e);
                }
            }
        },
    });
});
//# sourceMappingURL=Singleton.js.map